module.exports = __webpack_public_path__ + "kz.c70a8bdcbb0a76f928e8.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/kz.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/kz.svg
// module chunks = styles